import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismButton,
  PrismLoadingBar,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import HotelBenchmarkInsightCompetitorsCompetitorsListHeaders from 'lumen/components/hotel/benchmark-insight/competitors/competitors-list-headers';
import HotelBenchmarkInsightCompetitorsCompetitorsListItem from 'lumen/components/hotel/benchmark-insight/competitors/competitors-list-item';
import type { BenchmarkInsightCompetitorsCompetitor } from 'lumen/models';

import styles from './competitors-list.module.css';

interface HotelBenchmarkInsightCompetitorsCompetitorsListSignature {
  Args: {
    compset: BenchmarkInsightCompetitorsCompetitor[];
    isLoading: boolean;
  };
}

export default class HotelBenchmarkInsightCompetitorsCompetitorsList extends Component<HotelBenchmarkInsightCompetitorsCompetitorsListSignature> {
  @service declare intercom: Services['intercom'];

  @action
  showIntercomMessage(): void {
    this.intercom.showNewMessage();
  }

  <template>
    <div class={{styles.container}}>
      {{#if (and @isLoading (not @compset.length))}}
        <div class={{styles.loading-bar}}>
          <PrismLoadingBar />
        </div>
      {{/if}}

      {{#unless @isLoading}}
        {{#if @compset.length}}
          <HotelBenchmarkInsightCompetitorsCompetitorsListHeaders
            @compset={{@compset}}
            @isLoading={{@isLoading}}
          />

          <div class={{styles.competitors-list-outer}}>
            <div class={{styles.competitors-list-inner}}>
              {{#each @compset as |competitor|}}
                <HotelBenchmarkInsightCompetitorsCompetitorsListItem
                  @competitor={{competitor}}
                />
              {{/each}}
            </div>
          </div>
        {{else}}
          <div class={{styles.no-competitors}}>
            <PrismMessage
              @description={{t
                "settings.competitors.benchmark-insight.empty_compset"
              }}
              @illustration="100x100_warning"
              @title={{t "settings.competitors.empty_compset.title"}}
            >
              <:primaryAction>
                <PrismButton
                  @label={{t
                    "settings.competitors.benchmark-insight.empty_compset.cta"
                  }}
                  @onClick={{this.showIntercomMessage}}
                />
              </:primaryAction>
            </PrismMessage>
          </div>
        {{/if}}
      {{/unless}}
    </div>
  </template>
}
